import { Controller } from "@hotwired/stimulus"

// Turnstile の確認が終わる前に送信すると 422 になるので、確認が終わるまで送信ボタンを止める。
// script が読めない・失敗が続く環境で押せないまま残さないよう、止めてから fallbackDelay の後で押せるようにする (判定はサーバーが行う)
export default class extends Controller {
  static targets = ["submit", "waiting", "failed", "errorCode"]
  static values = { fallbackDelay: { type: Number, default: 10_000 } }

  // api.js は async なので、この controller より先に確認が終わっていることがある
  connect() {
    if (this.element.querySelector("input[name='cf-turnstile-response']")?.value) {
      this.enable()
    } else {
      this.disable()
    }
  }

  disconnect() {
    clearTimeout(this.fallbackTimeout)
  }

  succeeded() {
    this.failedTarget.hidden = true
    this.enable()
  }

  expired() {
    this.disable()
  }

  // Turnstile は失敗のたびに再試行して callback を呼び直すので、ここでボタンを止めると押せるようになる期限が延び続ける
  failed({ detail: { errorCode } }) {
    this.errorCodeTarget.textContent = errorCode
    this.failedTarget.hidden = false
    this.waitingTarget.hidden = true
  }

  enable() {
    clearTimeout(this.fallbackTimeout)
    this.submitTarget.disabled = false
    this.waitingTarget.hidden = true
  }

  disable() {
    clearTimeout(this.fallbackTimeout)
    this.submitTarget.disabled = true
    this.waitingTarget.hidden = false
    this.fallbackTimeout = setTimeout(() => this.enable(), this.fallbackDelayValue)
  }
}
